<template>
  <section class="container">
    <div class="shopping-step1">
      <template v-if="ShoppingData.shoppings.length">
        <Progress :step.sync="step" />

        <OrderDetail
          :IsReady="IsReady"
          :step.sync="step"
          :ShoppingData.sync="ShoppingData"
          @pushDelete="Delete"
        />

        <div v-if="IsReady" class="shopping-step1__actions">
          <button
            class="shopping-step1__submit"
            type="button"
            @click.prevent="next"
          >
            {{ $t('common.button.nextStep') }}
          </button>
        </div>
      </template>

      <div v-else class="shopping-step1__empty">
        <i class="el-icon-shopping-cart-2"></i>
        <p>{{ $t('shopping.message.emptyCart') }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import OrderDetail from '@/components/Shopping/OrderDetail.vue';
import Progress from '@/components/Shopping/Progress.vue';
import {
  GetShoppingCart,
  DeleteShoppingCartByCourse,
  SaveShoppingCart,
} from '@/api/ShoppingCartApi';

export default {
  components: {
    OrderDetail,
    Progress,
  },
  data() {
    return {
      step: 0,
      shoppingCount: 0,
      ShoppingData: {
        orderId: 0,
        shoppings: [
          {
            courseId: 0,
            courseName: '',
            courseOriPrice: 0,
            coursePrice: 0,
            classCount: 0,
            shoppingCartDetails: [
              {
                classId: 0,
                className: '',
                subjectName: '',
                teacherName: '',
              },
            ],
          },
        ],
        discountId: 0,
        discountMode: 0,
        discountName: '',
        discountCode: '',
        discountType: 0,
        discountPrice: 0,
        discountPercent: 0,
        discountMoney: 0,
        orderName: '',
        orderPhone: '',
        orderZipCode: '',
        orderAddress: '',
        orderNote: '',
        orderPayMode: 0,
        orderPayModeName: '',
      },
      IsReady: false,
    };
  },
  created() {
    this.GetShoppingCart();
  },
  methods: {
    GetShoppingCart() {
      GetShoppingCart().then((response) => {
        if (response.data.statusCode === 0) {
          this.$bus.$emit('getShoppingCartCount');
          this.ShoppingData = response.data.data;
          this.ShoppingData.shoppings.forEach((item) => {
            if (item.courseType === 2) {
              item.optionalChooseList.forEach((item2) => {
                this.$set(item2, 'teacherChoose', []);
                item2.optionalTeacherList.forEach((item3) => {
                  if (item3.hasTeacher) {
                    item2.teacherChoose.push(item3.teacherId);
                  }
                });
              });
            }
          });
          this.IsReady = true;
        }
      });
    },
    Delete(id, name) {
      this.$confirm(this.$t('shopping.confirm.removeFromCart', { courseName: name }), this.$t('common.dialog.title'), {
        confirmButtonText: this.$t('common.button.confirm'),
        cancelButtonText: this.$t('common.button.cancel'),
        type: 'warning',
      })
        .then(() => {
          DeleteShoppingCartByCourse(id).then((response) => {
            if (response.data.statusCode === 0) {
              this.GetShoppingCart();
            }
          });
        })
        .catch(() => {});
    },
    next() {
      const postData = { ...this.ShoppingData };
      let error = false;
      let havType2 = false;
      postData.shoppings.forEach((item) => {
        if (item.courseType === 2) {
          havType2 = true;
          item.optionalChooseList.forEach((item2) => {
            // 檢核師資是否都選取
            if (item2.teacherChoose.length !== item2.courseOptionalLimit) {
              error = true;
            }
            item2.optionalTeacherList.forEach((item3) => {
              // eslint-disable-next-line no-param-reassign
              item3.hasTeacher = this._.includes(item2.teacherChoose, item3.teacherId);
            });
          });
        }
      });

      // 目前無自選講師，先註解
      // if (error) {
      //   this.$message({ showClose: true, type: 'error', message: this.$t('shopping.message.selectTeacher') });
      //   return;
      // }
      if (havType2) {
        // this.$confirm(this.$t('shopping.confirm.teacherSelection'), this.$t('common.dialog.title'), {
        //   confirmButtonText: this.$t('common.button.confirm'),
        //   cancelButtonText: this.$t('common.button.cancel'),
        //   type: 'warning',
        // }).then(() => {
        //   SaveShoppingCart(postData).then((response) => {
        //     if (response.data.statusCode === 0) {
        //       this.$router.push({ name: 'Step2', params: { check: 'true' } });
        //     }
        //   });
        // });
      } else {
        SaveShoppingCart(postData).then((response) => {
          if (response.data.statusCode === 0) {
            this.$router.push({ name: 'Step2', params: { check: 'true' } });
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.shopping-step1 {
  &__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
  }

  &__submit {
    padding: 12px 40px;
    font-size: var(--font-size-base);
    font-weight: 600;
    color: var(--text-white);
    background-color: var(--primary-darken-color);
    border: 2px solid var(--primary-darken-color);
    border-radius: var(--border-radius-base);
    cursor: pointer;
    transition: all var(--transition-base);
    display: inline-flex;
    align-items: center;
    gap: 8px;

    i {
      font-size: 16px;
    }

    &:hover {
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }

    @media (max-width: $breakpoint-sm) {
      width: 100%;
      justify-content: center;
      padding: 12px 32px;
    }
  }

  &__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    background-color: var(--background-white);
    border-radius: var(--border-radius-lg);
    border: 1px solid var(--border-lighter);
    text-align: center;
    min-height: 350px;

    i {
      font-size: 72px;
      color: var(--text-placeholder);
      margin-bottom: 20px;
    }

    p {
      font-size: var(--font-size-lg);
      color: var(--text-secondary);
      margin: 0 0 24px 0;
    }
  }
}
</style>
